// extracted by mini-css-extract-plugin
module.exports = {"control":"Controls_control__1SHHZ","mirror":"Controls_mirror__1p-4v"};